/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Plan_Choose_TitleInputs */

const en_dr_plan_choose_title = /** @type {(inputs: Dr_Plan_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from a Design Room`)
};

const id_dr_plan_choose_title = /** @type {(inputs: Dr_Plan_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari Design Room`)
};

/**
* | output |
* | --- |
* | "Start from a Design Room" |
*
* @param {Dr_Plan_Choose_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_plan_choose_title = /** @type {((inputs?: Dr_Plan_Choose_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Plan_Choose_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_plan_choose_title(inputs)
	return en_dr_plan_choose_title(inputs)
});